import { Component, Vue } from "vue-property-decorator";
import { isWechat, isIOS } from './utils';
import { getJsConfig } from './api';

@Component
export default class WeixinMixin extends Vue {
  mounted() {
    if (isWechat) {
      console.log('share url:', this.shareUrl);
      document.addEventListener('WeixinOpenTagsError', (e) => console.error((e as any).detail.errMsg));
      this.configWeixinJSSDK();
    }
  }

  private configWeixinJSSDK(): void {
    const url = isIOS ? this.$store.getters.enterUrl : window.location.href;
    console.log('js-sdk config url', url);
    // 打开小程序的参考
    // https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/Wechat_Open_Tag.html
    getJsConfig(url).then(res => {
      const config = Object.assign({
        debug: false,
        jsApiList: ['hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'updateAppMessageShareData', 'updateTimelineShareData'],
        openTagList: ['wx-open-launch-weapp']
      }, res);

      const delay = isIOS ? 200 : 20;
      window.setTimeout(() => {
        this.doConfigWeixinJSSDK(config);
      }, delay);
    }).catch(err => {
      console.log('Catch weixin js-sdk except: ', err);
    });
  }

  private doConfigWeixinJSSDK(config: unknown) {
    console.log('set weixin config: ', config);
    window.wx.config(config);
    window.wx.error((err: unknown) => {
      console.log('Weixin js-sdk config failed: ', err);
    });

    window.wx.ready(() => {
      this.setupMenu();
      this.setupShare();
      this.setupTimelineShare();
    });
  }

  private setupMenu() {
    window.wx.hideAllNonBaseMenuItem({
      success: () => {
        window.wx.showMenuItems({
          menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:favorite'], // 要显示的菜单项，所有menu项见附录3
          success: () => {
            console.debug('showMenuItems success!');
          },
          fail: (res: unknown) => {
            console.error('showMenuItems failed: ', res);
          },
        });
      }
    });
  }

  get shareUrl(): string {
    const href = location.origin + location.pathname;
    return href;
  }

  public setupShare() {
    window.wx.updateAppMessageShareData({
      title: this.$store.getters.title,
      desc: this.$store.getters.title,
      imgUrl: this.$store.getters.thumbnail,
      link: this.shareUrl,
      success: () => {
        console.debug('updateAppMessageShareData success!');
      },
      fail: (res: unknown) => {
        console.error('updateAppMessageShareData failed: ', res);
        console.error('title: ', this.$store.getters.title);
        console.error('thumbnail: ', this.$store.getters.thumbnail);
      }
    });
  }

  public setupTimelineShare() {
    window.wx.updateTimelineShareData({
      title: this.$store.getters.title,
      desc: this.$store.getters.title,
      imgUrl: this.$store.getters.thumbnail,
      link: this.shareUrl,
      success: () => {
        console.debug('updateTimelineShareData success!');
      },
      fail: (res: unknown) => {
        console.error('updateTimelineShareData failed: ', res);
        console.error('title: ', this.$store.getters.title);
        console.error('thumbnail: ', this.$store.getters.thumbnail);
      }
    });
  }
}
